var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    { class: { "absolute-header": _vm.absolute } },
    [
      _vm.loader
        ? _c(
            "v-overlay",
            { attrs: { value: _vm.loading, "z-index": "999" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-list-item",
        [
          _c(
            "v-list-item-content",
            [
              _c(
                "v-list-item-title",
                { staticClass: "soli-subtitle" },
                [
                  _vm.dateRange.length && !_vm.legacyDate
                    ? _c(
                        _vm.datePicker.menuComp,
                        _vm._b(
                          {
                            tag: "component",
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "div",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "flex align-center",
                                              staticStyle: {
                                                width: "min-content",
                                              },
                                            },
                                            "div",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.getTitle) +
                                              "\n                            "
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                small: "",
                                                right: "",
                                                color: "dark",
                                              },
                                            },
                                            [_vm._v("keyboard_arrow_down")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              787261331
                            ),
                            model: {
                              value: _vm.picker,
                              callback: function ($$v) {
                                _vm.picker = $$v
                              },
                              expression: "picker",
                            },
                          },
                          "component",
                          { ..._vm.datePicker.menuProps },
                          false
                        ),
                        [
                          _vm._v(" "),
                          _c("DateRange", {
                            attrs: {
                              value: _vm.dateRange,
                              dateOptions: _vm.dateOptions,
                              month: _vm.monthSelector,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.updateRange({
                                  ...$event,
                                  allLocations: _vm.allLocations,
                                })
                              },
                              clear: function ($event) {
                                _vm.picker = false
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "flex align-center" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.getTitle) +
                            "\n                "
                        ),
                      ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.updated
                ? _c("small", [
                    _vm._v(
                      _vm._s(
                        `Last updated ${_vm.globalMomentDateAtTime(
                          new Date(_vm.updated)
                        )}`
                      )
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-list-item-subtitle",
                { staticStyle: { "white-space": "normal" } },
                [_vm._v(_vm._s(_vm.subtitle) + "\n            ")]
              ),
              _vm._v(" "),
              _vm.can("View admin reports") && _vm.locationOptions
                ? _c(
                    "v-list-item-subtitle",
                    {
                      staticClass: "font-bold py-1",
                      staticStyle: { "white-space": "normal" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "soli-round soli-blue-text",
                          attrs: { "x-small": "", outlined: "" },
                          on: {
                            click: function ($event) {
                              return _vm.jumpDate(0, !_vm.allLocations)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.allLocations
                                ? `View ${_vm.selectedLocation.name}`
                                : `View All Locations`
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("extendedSubtitle"),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-list-item-action",
            [
              _c(
                "v-row",
                { staticClass: "justify-end" },
                [
                  _vm.filter
                    ? _c(
                        _vm.dialog.menuComp,
                        _vm._b(
                          {
                            tag: "component",
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "elevation-3",
                                              class: {
                                                "mr-4": _vm.dateSelection,
                                              },
                                              attrs: {
                                                id: "menu-button",
                                                small:
                                                  _vm.$vuetify.breakpoint.xs,
                                                color: "white",
                                                icon: "",
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-badge",
                                            {
                                              attrs: {
                                                color: "accent",
                                                overlap: "",
                                                bordered: "",
                                                dot: "",
                                                value:
                                                  _vm.search || _vm.filterData,
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "soli-blue-text text-shadow-blue",
                                                },
                                                [_vm._v("tune")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              528909045
                            ),
                            model: {
                              value: _vm.menu,
                              callback: function ($$v) {
                                _vm.menu = $$v
                              },
                              expression: "menu",
                            },
                          },
                          "component",
                          { ..._vm.dialog.menuProps },
                          false
                        ),
                        [
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { staticClass: "safe-bottom" },
                            [
                              !_vm.hideSearch
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Filter",
                                          "single-line": "",
                                          outlined: "",
                                          dense: "",
                                          clearable: "",
                                          "append-icon": _vm.search
                                            ? null
                                            : "tune",
                                          "hide-details": "",
                                          autofocus: "",
                                        },
                                        model: {
                                          value: _vm.search,
                                          callback: function ($$v) {
                                            _vm.search = $$v
                                          },
                                          expression: "search",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              false
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: "Group By",
                                          dense: "",
                                          outlined: "",
                                          "item-text": "display",
                                          "item-value": "value",
                                          items: [
                                            {
                                              display: "Total",
                                              value: null,
                                            },
                                            {
                                              display: "Location",
                                              value: "location",
                                            },
                                            {
                                              display: "Date",
                                              value: "date",
                                            },
                                          ],
                                          "return-object": "",
                                          "hide-details": "",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.$emit(
                                              "setGroupBy",
                                              $event
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.groupBy,
                                          callback: function ($$v) {
                                            _vm.groupBy = $$v
                                          },
                                          expression: "groupBy",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._t("filterItem"),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.dateSelection
            ? _c(
                "v-list-item-action",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "elevation-3",
                          attrs: {
                            small: _vm.$vuetify.breakpoint.xs,
                            icon: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.jumpDate(-1, _vm.allLocations)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { color: "dark" } }, [
                            _vm._v("chevron_left"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "elevation-3 ml-1",
                          attrs: {
                            small: _vm.$vuetify.breakpoint.xs,
                            icon: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.jumpDate(1, _vm.allLocations)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { color: "dark" } }, [
                            _vm._v("chevron_right"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      false
                        ? _c("v-text-field", {
                            staticClass: "pl-6",
                            staticStyle: { width: "200px" },
                            attrs: {
                              "append-icon": "filter_list",
                              label: "Filter",
                              "single-line": "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }